module.exports = __webpack_public_path__ + "img/uranus.5c640130.png";